export default __webpack_public_path__ + "static/media/redmi4.f8adb40d.jpg";